const onRun = () => {
    // Menu open
    const menuOpen = document.getElementById('js-open-menu');
    if (menuOpen) {
        menuOpen.addEventListener('click', function () {
            document.body.classList.add('opened-mobile-menu');
        });
    }
    // Menu close
    const menuClose = document.getElementById('js-close-menu');
    if (menuClose) {
        menuClose.addEventListener('click', function () {
            document.body.classList.remove('opened-mobile-menu');
        });
    }
    // Menu item open
    const menuExpand = document.querySelectorAll(".js-menu-expand");
    if (menuExpand) {
        menuExpand.forEach((item) => {
            item.addEventListener('click', function () {
                console.log("open");
                this.closest('li').classList.toggle('js-menu-open');
            });
        });
    }

    // Footer menu toggle
    const menuFooterItem = document.querySelectorAll(".footer .depth-1 > li > span");
    if (menuFooterItem) {
        menuFooterItem.forEach((item) => {
            item.addEventListener('click', function () {
                this.closest('li').classList.toggle('is-open');
            });
        });
    }
};

if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}

